import { useLocalObservable } from 'mobx-react';
import { useContext } from 'react';
import { AppContext } from './Contexts.js';

function useAppService() {
    const context = useContext(AppContext);
    return useLocalObservable(() => context);
}

export { useAppService as default };
//# sourceMappingURL=useAppService.js.map
